<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Daily TPT Expense Details</b-navbar-brand>
        </b-navbar>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Type</label>
                  <model-list-select
                    :list="CustomDateList"
                    v-model="Filter.QDFilter"
                    option-value="DVal"
                    option-text="DText"
                    placeholder="Select"
                    :isDisabled="Filter.QFlag"
                    @input="getCurrentLastDate()"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker
                    :always-show-calendars="showCal"
                    v-model="Filter.dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    :disabled="Filter.DFlag ? true : false"
                    @update="getAssignmentData"
                  ></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select
                    :list="$store.getters['common/getAllBranchList']"
                    id="branchfilter"
                    v-model="Filter.branchfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="getAssignmentData"
                    :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    "
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientfilter"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="getAssignmentData"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Pickup</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllPickupList']"
                    v-model="Filter.PICKfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Pickup Location"
                    @input="getAssignmentData"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Stuffing</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllStuffingList']"
                    v-model="Filter.STUFFfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Stuffing Location"
                    @input="getAssignmentData"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Handover</label>
                  <model-list-select
                    :list="$store.getters['commonDropdownMaster/getAllHandoverList']"
                    v-model="Filter.HANDfilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="Select Handover Location"
                    @input="getAssignmentData"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>BOE Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search BOE Filter"
                    id="BOEfilter"
                    name="BOEfilter"
                    autocomplete="off"
                    v-model="Filter.BOEfilter"
                    @input="getAssignmentData"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Shipper INV Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Shipper INV Filter"
                    id="SHIPBillNofilter"
                    name="SHIPBillNofilter"
                    autocomplete="off"
                    v-model="Filter.SHIPBillNofilter"
                    @input="getAssignmentData"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Booking NO Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Booking NO Filter"
                    id="BookingNofilter"
                    name="BookingNofilter"
                    autocomplete="off"
                    v-model="Filter.BookingNofilter"
                    @input="getAssignmentData"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input
                    type="text"
                    :formatter="capitalizeAll"
                    placeholder="Search Common Filter"
                    id="CommonFilter"
                    name="CommonFilter"
                    autocomplete="off"
                    v-model="Filter.CommonFilter"
                    @input="getAssignmentData"
                  ></b-form-input>
                </b-col>
                <b-col md="3" class="mt-2">
                  <b-button
                    size="sm"
                    style="font-size: 0.675rem margin-left: auto"
                    class="ml-1 pull-right"
                    @click="clearFilter"
                    variant="danger"
                    >Reset</b-button
                  >
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>

        <b-card>
          <b-row>
            <b-col md="12">
              <b-navbar toggleable="lg" type="dark" variant="info">
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <h6 class="error" v-if="DateLabel.StartDate">
                      Start Date : {{ DateLabel.StartDate }} / End Date :
                      {{ DateLabel.EndDate }}
                    </h6>
                    <b-button-group size="sm" class="m2-1 text-right">
                      <b-button
                        style="font-size: 0.675rem"
                        :variant="
                          Filter.CommonFilter ||
                          Filter.clientIdFilter ||
                          Filter.branchfilter ||
                          Filter.PICKfilter ||
                          Filter.HANDfilter ||
                          Filter.STUFFfilter ||
                          Filter.BOEfilter ||
                          Filter.SHIPBillNofilter ||
                          Filter.BookingNofilter ||
                          Filter.QDFilter ||
                          Filter.QFlag ||
                          Filter.DFlag ||
                          Filter.dateRange.startDate ||
                          Filter.dateRange.endDate
                            ? 'danger'
                            : 'primary'
                        "
                        :class="'ml-4' + visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'"
                        aria-controls="collapse-4"
                        @click="visible = !visible"
                        >{{
                          Filter.CommonFilter ||
                          Filter.clientIdFilter ||
                          Filter.branchfilter ||
                          Filter.PICKfilter ||
                          Filter.HANDfilter ||
                          Filter.STUFFfilter ||
                          Filter.BOEfilter ||
                          Filter.SHIPBillNofilter ||
                          Filter.BookingNofilter ||
                          Filter.QDFilter ||
                          Filter.QFlag ||
                          Filter.DFlag ||
                          Filter.dateRange.startDate ||
                          Filter.dateRange.endDate
                            ? "Filter ON"
                            : "Filter OFF"
                        }}</b-button
                      >

                      <b-button class="mr-2" variant="secondary" @click="goBack"
                        >Back</b-button
                      >
                    </b-button-group>
                  </b-nav-form>
                </b-navbar-nav>
              </b-navbar>
            </b-col>
            <b-col md="12" class="mt-1" v-if="getTPTExpenseList.length > 0">
              <div>
                <b-pagination
                  limit="8"
                  align="center"
                  v-model="pagination.currentPage"
                  :per-page="pagination.perPage"
                  :total-rows="getTPTExpenseList.length"
                  @change="onPageChange($event)"
                ></b-pagination>
              </div>
              <div class="gutr">
                <h5 class="text-muted pull-right mt-2">
                  <small v-if="isLoading == false"
                    >{{ getTPTExpenseList.length }} Entries</small
                  >
                </h5>
              </div>
              <div class="table-responsive tableMain gutr">
                <b-table
                  show-empty
                  stacked="md"
                  :items="getTPTExpenseList"
                  responsive
                  :fields="TPTExpfields"
                  primary-key="allModuleId"
                  :per-page="pagination.perPage"
                  :current-page="pagination.currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  class="position-relative"
                >
                  <template slot="allModuleId" slot-scope="row0">
                    <span>{{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                    }}</span>
                  </template>
                  <template slot="JOBNO" slot-scope="row1">
                    <span>JOB NO : {{ row1.item.JOBNO }}<br /></span>
                    <span>JOB Date : {{ row1.item.JOBDate }}<br /></span>
                    <span>RaisedBy : {{ row1.item.RaisedBy }}<br /></span>
                    <span>Rasied From : {{ row1.item.RasiedFrom }}<br /></span>
                  </template>
                  <template slot="clientName" slot-scope="row2">
                    <span>Client : {{ row2.item.clientName }}<br /></span>
                    <span>Sline : {{ row2.item.Sline }}<br /></span>
                  </template>
                  <template slot="BOE" slot-scope="row3">
                    <span>{{ row3.item.BOE }}</span>
                  </template>
                  <template slot="PICK" slot-scope="row4">
                    <span>PICK : {{ row4.item.PICK }}<br /></span>
                    <span>HAND : {{ row4.item.HAND }}<br /></span>
                    <span>STUFF : {{ row4.item.STUFF }}<br /></span>
                  </template>

                  <template slot="HAND" slot-scope="row6">
                    <b-button
                      @click="AddMain(row6.item)"
                      :variant="row6.item.AddTypevalue == '1' ? 'info' : 'danger'"
                      size="xs"
                      style="font-size: 0.675rem"
                      class="mt-1"
                      >{{ row6.item.AddTypeLabel }}</b-button
                    >
                  </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="formCard" v-if="AssTPTExpArr.length > 0">
          <b-card-text v-for="(ass_itm, ass_idx) in AssTPTExpArr" :key="ass_idx">
            <div>
              <b-row>
                <b-col lg="4">
                  <b style="color: blue; font-weight: bold; font-size: 18px"
                    >JOB No : {{ ass_itm.JOBNO }}</b
                  >
                  <span class="error" v-if="ass_itm.JOBNO_err">{{
                    ass_itm.JOBNO_err
                  }}</span>
                </b-col>

                <b-col lg="8">
                  <span
                    v-if="
                      last_updated != '' &&
                      last_updated != null &&
                      last_updated != undefined
                    "
                    class="pull-right"
                    ><b class="error">{{ last_updated }}</b></span
                  >
                  <b-button
                    class="ml-auto pull-right"
                    id="show-btn"
                    size="sm"
                    variant="danger"
                    style="font-size: 0.675rem"
                    @click="removeMain(ass_idx)"
                  >
                    Remove
                    <i class="fa fa-minus" aria-hidden="true"></i>
                  </b-button>
                </b-col>
              </b-row>
              <b-card class="mt-2">
                <div class="table-responsive tableMain">
                  <table class="table table-sm table-bordered">
                    <tbody style="background: white">
                      <tr>
                        <th scope="col">SN.</th>
                        <th scope="col">
                          Amount <span class="error">* (Required)</span>
                        </th>
                        <th scope="col">
                          Currency<span class="error">* (Required)</span>
                        </th>
                        <th scope="col">
                          Description<span class="error">* (Required)</span>
                        </th>
                        <th scope="col">Remarks</th>
                        <th scope="col">Doc.</th>
                        <th scope="col">
                          Action
                          <b-button
                            id="show-btn"
                            size="sm"
                            variant="primary"
                            style="font-size: 0.675rem"
                            @click="addTPTExp(ass_idx, ass_itm)"
                          >
                            Add <i class="fa fa-plus" aria-hidden="true"></i
                          ></b-button>
                        </th>
                      </tr>
                      <tr v-for="(itm, idx) in ass_itm.TPTExpArr" :key="idx">
                        <th scope="row">{{ idx + 1 }}</th>

                        <td>
                          <b-form-input
                            :disabled="itm.exp_id != '' ? true : false"
                            :formatter="capitalizeAll"
                            id="amount"
                            name="amount"
                            v-model="itm.exp_amt"
                            @input="CheckValueNumbers($event)"
                            @change="CheckValueNumbers($event)"
                            v-on:keyup="TotalAMT(ass_itm, ass_idx, idx, itm)"
                            type="number"
                          ></b-form-input>
                          <span class="error" v-if="itm.exp_amt_err">{{
                            itm.exp_amt_err
                          }}</span>
                        </td>
                        <td>
                          <model-list-select
                            :isDisabled="true"
                            :list="$store.getters['common/getAllCurrencyList']"
                            v-model="itm.exp_currency_id"
                            option-value="currency_id"
                            option-text="currencyCode"
                            placeholder="Select Currency"
                          ></model-list-select>
                          <span class="error" v-if="itm.exp_currency_id_err">{{
                            itm.exp_currency_id_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-textarea
                            :disabled="itm.exp_id != '' ? true : false"
                            :formatter="capitalizeAll"
                            id="description"
                            name="description"
                            v-model="itm.exp_desc"
                          ></b-form-textarea>
                          <span class="error" v-if="itm.exp_desc_err">{{
                            itm.exp_desc_err
                          }}</span>
                        </td>
                        <td>
                          <b-form-textarea
                            :disabled="itm.exp_id != '' ? true : false"
                            :formatter="capitalizeAll"
                            id="remark"
                            name="remark"
                            v-model="itm.exp_remark"
                          ></b-form-textarea>
                          <span class="error" v-if="itm.exp_remark_err">{{
                            itm.exp_remark_err
                          }}</span>
                        </td>
                        <td>
                          <Single-Upload
                            :index="ass_idx"
                            :second_index="idx"
                            :multiple="false"
                            :documentName="'TPTExpense_Multiple_Doc_'"
                            :otherDocName="'TPTExpense_Multiple_Doc_'"
                            :folderName="'Expense'"
                            :accept="'*'"
                            v-model="itm.exp_doc"
                            :state="Boolean(itm.exp_doc)"
                            :assign_no="ass_itm.JOBNO"
                            :fileAllModuleId="ass_itm.allModuleId"
                          />
                          <span class="error" v-if="itm.exp_doc_err">{{
                            itm.exp_doc_err
                          }}</span
                          ><br />
                          <a
                            v-if="ass_itm.doc_path && itm.exp_doc"
                            :href="
                              `${docURL}/ASSIGNMENT_UPLOADS/` +
                              ass_itm.doc_path +
                              '/' +
                              itm.exp_doc
                            "
                            target="_blank"
                            download
                            >--View</a
                          >
                        </td>
                        <td>
                          <b-button
                            :disabled="itm.exp_id != '' ? true : false"
                            class="ml-auto"
                            id="show-btn"
                            size="sm"
                            variant="danger"
                            style="font-size: 0.675rem"
                            @click="removeTPTExp(idx, ass_idx, ass_itm, itm)"
                          >
                            Remove
                            <i class="fa fa-minus" aria-hidden="true"></i
                          ></b-button>
                        </td>
                      </tr>

                      <tr>
                        <td colspan="1">
                          <b style="color: blue; font-weight: bold; font-size: 18px"
                            >Net Total</b
                          >
                        </td>
                        <td colspan="5">
                          <b style="color: blue; font-weight: bold; font-size: 18px">{{
                            ass_itm.exp_netTot + " INR"
                          }}</b>
                          <span class="error" v-if="ass_itm.exp_netTot_err">{{
                            ass_itm.exp_netTot_err
                          }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-card>
            </div>
          </b-card-text>
          <b-row>
            <b-col lg="5">
              <b style="color: red; font-weight: bold; font-size: 18px"
                >Final Total = {{ TotAMT + " INR" }}</b
              ></b-col
            >
            <b-col lg="2"
              ><b-button
                v-if="AssTPTExpArr.length > 0"
                class="mt-3"
                size="sm"
                variant="primary"
                id="addButtonLoaderSB"
                style="font-size: 0.675rem"
                @click="addAddTPTExpDetail"
                >Save & Submit
              </b-button>

              <md-spinner
                md-indeterminate
                id="loaderSB"
                style="display: none"
              ></md-spinner>
            </b-col>
            <b-col lg="5"></b-col>
          </b-row>
        </b-card>

        <md-dialog-confirm
          :md-content-html="alert.content"
          :md-ok-text="alert.ok"
          ref="addPop"
        ></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import Multiselect from "vue-multiselect";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
import TrasportService from "../../services/TrasportService.js";
import SingleUpload from "../common/singleUpload.vue";
import ClientUserService from "../../services/ClientUserService";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    let payload = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllPickupDDList",
      JSON.stringify({
        itemCode: "AllPickupList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllHandoverDDList",
      JSON.stringify({
        itemCode: "AllHandoverList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllStuffingDDList",
      JSON.stringify({
        itemCode: "AllStuffingList",
      })
    );
    if (globalPermissionStatus("Transportation")) {
      this.$store.dispatch("setCurrentRoute", "/transport/tptExpense");
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getAssignmentData();
      },
      deep: true,
    },
  },

  data() {
    return {
      DateLabel: {
        StartDate: "",
        EndDate: "",
      },
      PaginationCount: 0,
      totalRows: 0,
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      TPTExpfields: [
        {
          key: "allModuleId",
          mainkey: "allModuleId",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "JOBNO",
          mainkey: "JOBNO",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Sline",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "BOE",
          mainkey: "BOE",
          label: "Container No. // Shipping Bill No // Shipper Invoice No",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "validBookingNo",
          mainkey: "validBookingNo",
          label: "Booking No",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "PICK",
          mainkey: "PICK",
          label: "Loc. Details",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "HAND",
          mainkey: "HAND",
          label: "Actions",
          sortable: true,
          sortDirection: "ASC",
        },
      ],
      Filter: {
        CommonFilter: "",
        clientIdFilter: "",
        branchfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        STUFFfilter: "",
        BOEfilter: "",
        SHIPBillNofilter: "",
        BookingNofilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      getTPTExpenseList: [],
      visible: false,
      CustomDateList: [
        {
          DVal: "Q1",
          DText: "Q1",
        },
        {
          DVal: "Q2",
          DText: "Q2",
        },
        {
          DVal: "Q3",
          DText: "Q3",
        },
        {
          DVal: "Q4",
          DText: "Q4",
        },
        {
          DVal: "H1",
          DText: "H1",
        },
        {
          DVal: "H2",
          DText: "H2",
        },
      ],
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },

      TotAMT: 0,
      selectDateFormat,
      accounts: false,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      permissionStatus: true,

      role: this.$sessionsStorage.get("designation"),
      AssTPTExpArr: [],
      singleUpload: [],
      last_updated: "",
      validateExp: true,
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    SingleUpload,
  },
  created() {
    eventBus.$on("fileuploaded", (file) => {
      this.singleUpload = "";
      this.singleUpload = file;
    });
    eventBus.$on("fileuploadedsecondindex", (indexObj) => {
      console.log("fileuploadedsecondindex=>", indexObj);
      this.AssTPTExpArr[indexObj.index].TPTExpArr[
        indexObj.second_index
      ].exp_doc = this.singleUpload;
    });
  },
  computed: {
    disableSave() {
      return this.AssTPTExpArr.length <= 0 ? true : false;
    },
  },
  methods: {
    AddMain(item) {
      let data = this.AssTPTExpArr.filter((val, key) => {
        return val.allModuleId === item.allModuleId;
      });
      if (item.AddTypevalue == "1") {
        let obj = {
          JOBNO: item.JOBNO,
          JOBDate: item.JOBDate,
          RaisedBy: item.RaisedBy,
          RasiedFrom: item.RasiedFrom,
          clientName: item.clientName,
          Sline: item.Sline,
          BOE: item.BOE,
          PICK: item.PICK,
          HAND: item.HAND,
          STUFF: item.STUFF,
          validBookingNo: item.validBookingNo,
          doc_path: item.JOBNO.replaceAll("/", "_"),
          allModuleId: item.allModuleId,
          exp_netTot: 0,
          TPTExpArr: [
            {
              exp_id: "",
              exp_amt: "",
              exp_currency_id: "2",
              exp_currency_txt: "INR",
              exp_desc: "",
              exp_remark: "",
              exp_doc: "",
              exp_allModuleId: item.allModuleId,
            },
          ],
        };
        if (data.length <= 0) {
          this.AssTPTExpArr.push(obj);
        }
      } else if (item.AddTypevalue == "2") {
        let index = this.AssTPTExpArr.findIndex(
          (main) => main.allModuleId === item.allModuleId
        );

        if (index !== -1) {
          this.AssTPTExpArr.splice(index, 1);
        }
      }
      this.AddRemoveLabel();
    },
    removeMain(idx) {
      this.AssTPTExpArr.splice(idx, 1);
      if (this.AssTPTExpArr.length > 0) {
        this.TotalAMT();
      } else {
        this.TotAMT = 0;
      }
      this.AddRemoveLabel();
    },
    addTPTExp(ass_idx, item) {
      let obj = {
        allModuleId: item.allModuleId,
        exp_allModuleId: item.allModuleId,
        exp_id: "",
        exp_amt: "",
        exp_currency_id: "2",
        exp_currency_txt: "INR",
        exp_desc: "",
        exp_remark: "",
        exp_doc: "",
        exp_amt_err: "",
        exp_currency_id_err: "",
        exp_desc_err: "",
      };
      this.AssTPTExpArr[ass_idx].TPTExpArr.push(obj);
    },
    removeTPTExp(idx, ass_idx, ass_itm, itm) {
      ass_itm.TPTExpArr.splice(idx, 1);
      this.TotalAMT(ass_itm, ass_idx, idx, itm);
    },

    TotalAMT(ass_itm, ass_idx, idx, itm) {
      let TotAMT = 0;
      let amount = 0;
      if (this.AssTPTExpArr.length > 0) {
        if (ass_idx != undefined) {
          if (
            this.AssTPTExpArr[ass_idx].TPTExpArr &&
            this.AssTPTExpArr[ass_idx].TPTExpArr.length > 0
          ) {
            this.AssTPTExpArr[ass_idx].TPTExpArr.forEach((val, key) => {
              if (isNaN(val.exp_amt) || val.exp_amt == "" || val.exp_amt == 0) {
                amount = 0;
              } else {
                amount = val.exp_amt;
              }

              if (TotAMT == 0) {
                TotAMT = parseFloat(amount);
              } else {
                TotAMT = parseFloat(TotAMT) + parseFloat(amount);
              }
            });
          }
          this.AssTPTExpArr[ass_idx].exp_netTot = TotAMT;
        }
        this.getFinalTotal();
      }
    },
    getFinalTotal() {
      let TotAMT = 0;
      let amount = 0;
      this.AssTPTExpArr.forEach((val, key) => {
        if (isNaN(val.exp_netTot) || val.exp_netTot == "" || val.exp_netTot == 0) {
          amount = 0;
        } else {
          amount = val.exp_netTot;
        }
        if (TotAMT == 0) {
          TotAMT = parseFloat(amount);
        } else {
          TotAMT = parseFloat(TotAMT) + parseFloat(amount);
        }
      });
      this.TotAMT = TotAMT;
    },
    AddRemoveLabel() {
      if (this.getTPTExpenseList.length > 0) {
        this.getTPTExpenseList.forEach((val1, key1) => {
          val1.AddTypevalue = "1";
          val1.AddTypeLabel = "Add";
        });
      }
      if (this.getTPTExpenseList.length > 0 && this.AssTPTExpArr.length > 0) {
        for (let i = 0; i < this.AssTPTExpArr.length; i++) {
          for (let j = 0; j < this.getTPTExpenseList.length; j++) {
            if (
              this.getTPTExpenseList[j].allModuleId === this.AssTPTExpArr[i].allModuleId
            ) {
              this.getTPTExpenseList[j].AddTypevalue = "2";
              this.getTPTExpenseList[j].AddTypeLabel = "Remove";
              break;
            }
          }
        }
      }
    },

    validateAddTPTExpDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.AssTPTExpArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].JOBNO == "") {
          this.AssTPTExpArr[j]["JOBNO_err"] = "JOB NO Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.AssTPTExpArr[j]["JOBNO_err"] = "";
          validate_new = true;
        }

        if (MainARR[j].allModuleId == "") {
          this.AssTPTExpArr[j]["allModuleId_err"] = "All Module Id Field is Required";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.AssTPTExpArr[j]["allModuleId_err"] = "";
          validate_new = true;
        }

        if (MainARR[j].exp_netTot == "" || MainARR[j].exp_netTot == 0) {
          this.AssTPTExpArr[j]["exp_netTot_err"] =
            "Expense Net Total Value is Greater Than Zero";
          validate_new = false;
          ++errCount;
          break;
        } else {
          this.AssTPTExpArr[j]["exp_netTot_err"] = "";
          validate_new = true;
        }

        let TPTExpARR = MainARR[j].TPTExpArr;
        for (let k = 0; k < TPTExpARR.length; k++) {
          if (TPTExpARR[k].exp_amt == "") {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_amt_err"] =
              "Expense AMT Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_amt_err"] = "";
            validate_new = true;
          }

          if (TPTExpARR[k].exp_currency_id == "") {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_currency_id_err"] =
              "Currency Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_currency_id_err"] = "";
            validate_new = true;
          }

          if (TPTExpARR[k].exp_desc == "") {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_desc_err"] =
              "Descroiption Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.AssTPTExpArr[j].TPTExpArr[k]["exp_desc_err"] = "";
            validate_new = true;
          }
        }
      }

      if (errCount > 0) {
        this.validateExp = false;
      }
      if (validate_new == false) {
        this.validateExp = false;
      } else {
        this.validateExp = true;
      }
    },

    addAddTPTExpDetail() {
      this.validateAddTPTExpDetail();
      if (this.validateExp == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.validateExp != false) {
        this.isLoading = true;
        let paylod = {
          TPTExp: this.AssTPTExpArr,
          exp_finalTot: this.TotAMT,
          itemCode: "dailyTPTExpDetails",
        };
        ClientUserService.getAllOverseaLock(JSON.stringify(paylod))
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.texp_ids.length > 0) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.clearInputData();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch((error) => {
            console.log("Catch on getAllTrasportList Error: ", error);
          });
      }
    },

    clearInputData() {
      this.AssTPTExpArr = [];
    },

    CheckValueNumbers(item, arr) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
    getAssignmentData() {
      this.getTPTExpenseList = [];
      if (
        this.Filter.CommonFilter ||
        this.Filter.clientIdFilter ||
        this.Filter.branchfilter ||
        this.Filter.PICKfilter ||
        this.Filter.HANDfilter ||
        this.Filter.STUFFfilter ||
        this.Filter.BOEfilter ||
        this.Filter.SHIPBillNofilter ||
        this.Filter.BookingNofilter ||
        this.Filter.QDFilter ||
        this.Filter.QFlag ||
        this.Filter.DFlag ||
        this.Filter.dateRange.startDate ||
        this.Filter.dateRange.endDate
      ) {
        let paylod = {
          Filter: this.Filter,
          itemCode: "getAssList",
        };
        TrasportService.getAllTrasportList(JSON.stringify(paylod))
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data.getTPTExpenseList) {
              this.getTPTExpenseList = data.getTPTExpenseList;
              this.DateLabel.StartDate = data.startDate;
              this.DateLabel.EndDate = data.endDate;
              this.AddRemoveLabel();
            }
          })
          .catch((error) => {
            console.log("Catch on getAllTrasportList Error: ", error);
          });
      }
    },
    pagechangeData() {
      this.pagination.perPage = this.PaginationCount;
      this.getAssignmentData();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
    },
    goBack() {
      window.history.go(-1);
    },

    clearFilter() {
      this.getTPTExpenseList = [];
      this.Filter = {
        CommonFilter: "",
        clientIdFilter: "",
        branchfilter: "",
        PICKfilter: "",
        HANDfilter: "",
        STUFFfilter: "",
        BOEfilter: "",
        SHIPBillNofilter: "",
        BookingNofilter: "",
        QDFilter: "",
        QFlag: false,
        DFlag: false,
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      this.Filter.QFlag = false;
      this.Filter.DFlag = false;

      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = "";
      var firstDay_mm = "";
      var firstDay_yyyy = "";

      var lastDay_dd = "";
      var lastDay_mm = "";
      var lastDay_yyyy = "";
      if (this.Filter.QDFilter) {
        var Qdate = this.Filter.QDFilter;
        switch (Qdate) {
          case "Q1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);
            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q2": {
            var firstDay = new Date(today.getFullYear(), 6);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q3": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();
            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "Q4": {
            var firstDay = new Date(today.getFullYear(), 12);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy - 1) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H1": {
            var firstDay = new Date(today.getFullYear(), 3);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          case "H2": {
            var firstDay = new Date(today.getFullYear(), 9);
            var lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 6, 0);

            firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
            firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            firstDay_yyyy = firstDay.getFullYear();

            lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
            lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
            lastDay_yyyy = lastDay.getFullYear();

            firstDay =
              (firstDay_mm > 3 ? firstDay_yyyy - 1 : firstDay_yyyy) +
              "/" +
              firstDay_mm +
              "/" +
              firstDay_dd; //2018-06-01
            lastDay =
              (lastDay_mm > 3 ? lastDay_yyyy : firstDay_yyyy) +
              "/" +
              lastDay_mm +
              "/" +
              lastDay_dd; //2018-06-01
            break;
          }
          default: {
            // alert(">41");
          }
        }
        this.Filter.QFlag = false;
        this.Filter.DFlag = true;
      } else if (this.dateRange.startDate && !this.Filter.QDFilter) {
        this.Filter.QFlag = true;
        this.Filter.DFlag = false;
      }

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      // alert(this.Filter.QDFilter)
      this.getAssignmentData();
    },
    getCurrentDateTime() {
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      const now = new Date();
      return now.toLocaleString("en-GB", options);
    },

    // deselect option
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// dailyTPTExpense.vue?9a7b5602